<template>
	<div class="w-full justify-between items-start">
		<div class="lg:w-1/2 md:mb-8 lg:mb-0 overflow-hidden">
			<h2 class="heading mb-6 text-2xl font-bold">
				{{ $t("product.details.description") }}
			</h2>
			<div v-if="description" v-html="description" />
		</div>
		<div
			v-if="currentTabSpecification && currentTabSpecification.length > 0"
			class="py-8 px-6 lg:w-[37%] text-base bg-gray-100"
		>
			<h2 class="heading mb-1.5 text-lg font-bold">
				{{ $t("product.details.specifications") }}
			</h2>
			<div
				v-for="parametric in currentTabSpecification"
				:key="parametric.Id"
				class="flex justify-between flex-1 py-4 border-b border-gray-dark"
			>
				<span class="font-bold basis-[65%]">{{ parametric.Name }}</span>
				<span class="basis-[30%] flex justify-end">{{
					formatParametricValue(parametric.Value, t)
				}}</span>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { formatParametricValue } from "~/utils/product/parametricValues";
import type { VariantParametric } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";

const { t } = useI18n();

interface Props {
	description: string | undefined;
	currentTabSpecification: VariantParametric[] | undefined;
}

defineProps<Props>();
</script>
